module.exports = __webpack_public_path__ + "img/bsm.27ee7980.svg";